import { create } from "zustand";
import { persist } from "zustand/middleware";
import { RequestStatus } from "../utils/commons";
import type { ISessionState, IWidgetSession } from "../shared/session/interfaces/session";
import type { IErrorState } from "../shared/error/interfaces/error";

interface ISessionActions {
  setSession: (session: ISessionState) => void;
  updateSession: (data: IWidgetSession) => void;
  setError: (error: IErrorState) => void;
  resetSession: () => void;
}

export const useSessionStore = create<{ session: ISessionState } & ISessionActions>()(
  persist(
    (set) => ({
      session: {
        data: null,
        status: RequestStatus.NOT_LOADED,
        error: null,
      },
      setSession: (session) => {
        set(() => ({ session }));
      },
      updateSession: (data) => {
        set((state) => ({
          session: {
            ...state.session,
            data,
            status: RequestStatus.LOADED,
            error: null,
          },
        }));
      },
      setError: (error) => {
        set((state) => ({
          session: {
            ...state.session,
            status: RequestStatus.ERROR,
            error,
          },
        }));
      },
      resetSession: () => {
        set(() => ({
          session: {
            data: null,
            status: RequestStatus.NOT_LOADED,
            error: null,
          },
        }));
      },
    }),
    {
      name: "raas-widgets-screenbook-session",
      partialize: (state) => ({
        session: {
          data: state.session.data,
          status: RequestStatus.NOT_LOADED,
          error: null,
        },
      }),
    }
  )
);
